module.exports = __webpack_public_path__ + "static/media/stockhausen_haut_11.91127c76.jpg";